<template>
    <uw-content title="产品申领">
        <template slot="suffix">
            <el-button type="primary" size="mini" @click="$refs.applyCreate.Open()" >申领产品</el-button>
        </template>
        <uw-table>
            <template slot="search">
                <el-input @input="$lodash.debounce(TableSearch, 500)" v-model="search.number" clearable  size="mini" placeholder="报废单号"></el-input>
            </template>
            <template slot="button">
                <el-button type="primary" size="mini" @click="$refs.xTable.openExport()" >导出</el-button>
            </template>
            <template slot="data">
                <vxe-table
                    ref="xTable"
                    :data="table"
                    :loading="loading"
                    :export-config="{}"
                    :print-config="{}"
                    :seq-config="{startIndex: page.size * (page.current - 1)}"
                    height="100%">
                    <vxe-column width="80" title="状态">
                        <template #default="{ row }">
                            <el-tag v-if="row.confied_state == 0" size="mini" effect="dark" type="info">待审核</el-tag>
                            <el-tag v-if="row.confied_state == 1" size="mini" effect="dark">已同意</el-tag>
                            <el-tag v-if="row.confied_state == 2" size="mini" effect="dark" type="danger">已拒绝</el-tag>
                        </template>
                    </vxe-column>
                    <vxe-column width="140" title="报废单号">
                        <template #default="{ row }">
                            <span class="el-span-primary" @click="$refs.applyDrawer.Open(row.id)">{{ row.number }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column min-width="140" field="describe" title="申领备注"></vxe-column>
                    <vxe-column min-width="80" field="created_user.name" title="申领人"></vxe-column>
                    <vxe-column min-width="140" field="created_at" title="申领时间"></vxe-column>
                    <vxe-column min-width="80" field="confied_user.name" title="审核人"></vxe-column>
                    <vxe-column min-width="140" field="confied_at" title="审核时间"></vxe-column>
                    <vxe-column min-width="140" field="confied_describe" title="审核描述"></vxe-column>
                </vxe-table>
            </template>
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>
        </uw-table>
        <ims-product-apply-create ref="applyCreate" @onChange="TableSearch" />
        <ims-product-apply-drawer ref="applyDrawer" @onChange="TableSearch" />
    </uw-content>
</template>
<script>
export default {
    data () {
        return {
            table: [],
                        page: {
                total: 0,
                size: 50,
                current: 1,
            },
                        search: {
                warehoser_id: null,
                number: null,
                action: 0
            },
                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },
        computed: {
        loading () {
            return !!this.$store.state.httpRequestCount
        }
    },
    mounted () {
        this.TableSearch()
    },
    methods: {
                TableSearch() {
            this.$http.post(
                '/9api/ims/product-apply/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['created_user', 'confied_user']
                }
            ).then(rps => {
                                this.page.total = rps.data.total
                this.table = rps.data.body
                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }
            })
        }
    }
}
</script>